import {useEffect, useRef} from 'react'

function useUpdateEffect(callback: any, dependencies: any) {
  const firstRenderRef = useRef(true)

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false
      return
    }

    return callback()
  }, dependencies)
}

export default useUpdateEffect
